// removed by extract-text-webpack-plugin
module.exports = {"Section":"src-pages----index-module---Section---3cKk9","Column":"src-pages----index-module---Column---231-N","Column--offset":"src-pages----index-module---Column--offset---1es5K","spinAround":"src-pages----index-module---spinAround---3pFBn"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.scss
// module id = 459
// module chunks = 35783957827783